import pathRegexp from 'path-to-regexp'
import { parse } from 'querystring'

const defaultEnvJump = window.jst_core.tab || {}

const getCurrentRoute = ({ router = [], pathname }) => {
    let result
    const filterRouter = (router = [], pathname) => {
        const current = router.find(({ routes, path = '/' }) => {
            return (path && pathRegexp(path).exec(pathname)) || (routes && filterRouter(routes, pathname))
        })
        if (current) {
            result = current
            return false
        }
    }
    filterRouter(router, pathname)
    return result
}

const NO_GYL_URLS = ['/']

const envJump = {
    ...defaultEnvJump,
    open: props => {
        let { url, ...otherProps } = props || {}

        // gyl无http链接 兼容erp环境
        if (!url.startsWith('http')) {
            const urlData = new URL(window.origin + url)
            const gylUrl = getCurrentRoute({ router: window.PROJECT_CONFIG.routes, pathname: urlData?.pathname })

            if (gylUrl && NO_GYL_URLS.indexOf(gylUrl?.path) === -1) {
                url = window.origin + url
            }
        }

        let extra = {}
        if (url.startsWith('/?n=')) {
            const { n, u } = parse(url.split('?')[1])
            if (u) {
                extra = {
                    name: n,
                    url: u,
                }
            } else {
                extra = {
                    menu: {
                        name: n,
                    },
                }
            }
        }

        defaultEnvJump.open({
            ...otherProps,
            url,
            ...extra,
        })
    },
}

export default envJump
